var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTime = function SvgTime(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_3_1",
    "data-name": "Component 3 \\u2013 1",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(-131 -59)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    y2: 10.87,
    transform: "translate(135.348 59)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x1: 10.87,
    transform: "translate(135.348 69.87)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M156,59a25,25,0,1,1-25,25",
    transform: "translate(-131 -59)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M135.391,69.87A24.928,24.928,0,0,1,156,59",
    transform: "translate(-131 -59)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    y2: 15.217,
    transform: "translate(26.087 10.87)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x1: 13.043,
    transform: "translate(26.087 26.087)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTime, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time.73fcf8a1.svg";
export { ForwardRef as ReactComponent };